import React, { Component } from 'react'
import InputRow from './InputRow'
import Loading from './Loading'
import PropTypes from 'prop-types'
export default class GovernmentInformation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      passportNumber: '',
      passportCountry: '',
      passportExpiryDate: (this.props.passportExpiry.split('T'))[0] || '',
      nationalNumber: '',
      error: '',
      pedError: '',
      inputError: '',
      loading: true

    }

    this.isNumeric = this.isNumeric.bind(this)
  }

 

  componentDidMount () {
    let passportDate = ''
    if (this.props.passportExpiry) {
      const date = new Date(this.props.passportExpiry)
      let month = date.getMonth() + 1
      let day = date.getDate()
      let year = date.getFullYear()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if (year < 10) {
        year = '000' + year
      } else if (year < 100) {
        year = '00' + year
      } else if (year < 1000) {
        year = '0' + year
      }
      passportDate = year + '-' + month + '-' + day
    }
    this.setState({
      nationalNumber: this.props.nationalIdNumber,
      passportNumber: this.props.passportNumber,
      passportCountry: this.props.passportCountry,
      passportExpiryDate: passportDate || '',
      loading: false
    })
  }

  isNumeric(number) {
    if (+number === +number) { // if is a number
        return true;
    }
  
    return false;
  }

  renderForeign () {
    const validationError = this.props.error
    const { passportNumber, passportCountry, passportExpiryDate ,pedError } = this.state
    return (
      <div>
        <div>
          <div>
            <InputRow
              name="text"
              rowName="Passport Number"
              required="*"
              errMsg={validationError.passportNumber ? validationError.passportNumber : ''}
              hover={"The number mentioned in your passport.\nالرقم المذكور في جواز سفرك"}
              value={passportNumber}
              onChange={(val) => {
                this.setState({ passportNumber: val })
                this.props.collectState('GI', {
                  passportNumber: val,
                  passportCountry: passportCountry,
                  passportExpiryDate: passportExpiryDate,
                  nationalNumber: ''
                })
              }}
            />
            <InputRow
              rowName="Passport Country Issued"
              value={passportCountry}
              name="select"
              data={this.props.countryData}
              onChange={(val) => {
                this.setState({ passportCountry: val })
                this.props.collectState('GI', {
                  passportNumber: passportNumber,
                  passportCountry: val,
                  passportExpiryDate: passportExpiryDate,
                  nationalNumber: ''
                })
              }}
              required='*'
              errMsg={validationError.passportCountry ? validationError.passportCountry : ''}
            />
            <InputRow
              rowName="Passport Expiration Date"
              value={passportExpiryDate}
              errMsg={pedError || (validationError.passportExpiryDate ? validationError.passportExpiryDate : '')}
              name="date"
              onChange={(val) => {
                
             const dob = new Date(val)
             const currentDate = new Date()

             if (!isNaN(dob.getFullYear())) {
               if (parseInt(dob.getFullYear()) <= 9999 )   {
                 this.setState({ passportExpiryDate: val })
                 this.props.collectState('GI', {
                   passportNumber: passportNumber,
                   passportCountry: passportCountry,
                   passportExpiryDate: val,
                   nationalNumber: ''
                 })
               }
             } else {
               this.setState({ passportExpiryDate: '' })
               this.props.collectState('GI', {
                 passportNumber: passportNumber,
                 passportCountry: passportCountry,
                 passportExpiryDate: '',
                 nationalNumber: ''
               })
             }

             if(dob <= currentDate )
             {
              this.setState({ pedError: 'Please enter a valid Passport expiry Date conditions.' , passportExpiryDate: ''})
              // alert('Please enter a valid Passport expiry Date conditions.');
              // this.setState({ passportExpiryDate: '' })
               this.props.collectState('GI', {
                 passportNumber: passportNumber,
                 passportCountry: passportCountry,
                 passportExpiryDate: '',
                 nationalNumber: ''
               })
             }
             else
             {
              this.setState({ pedError: '' })
             }
          
              }}
              required="*"
            />
          </div>
        </div>
      </div>
    )
  }

  renderLocal () {
    const validationError = this.props.error
    const { passportNumber, passportCountry, passportExpiryDate, nationalNumber } = this.state
    return (
      <div>
        <div>
          <div>
            <InputRow
              rowName="National ID Number"
              name="text"
              required="*"
              errMsg={validationError.nationalNumber ? validationError.nationalNumber : ''}
              hover={"Your National ID Number: 14 numbers only, characters are not allowed.\nرقم الهوية الوطنية الخاصة بك المؤلف من 14 رقما فقط."}
              value={nationalNumber}
              onChange={(val) => {
                if(this.isNumeric(val))
                {
                if ((val.length) < 15 || val === '') {
                const lengthError = val.length > 0 && val.length < 14 ? 'Please enter exactly 14 digits (' + val.length + '/14).' : ''
                this.setState({ nationalNumber: val, inputError: lengthError })
                this.props.collectState('GI', {
                  passportNumber: passportNumber,
                  passportCountry: passportCountry,
                  passportExpiryDate: passportExpiryDate,
                  nationalNumber: val
                })
              }
              } else { this.setState({ inputError: 'Please enter numbers only (14 digits).' }) }
            }
          }

            />
            {this.state.inputError && <p style={{ color: 'red', fontSize: 12, marginLeft: 5 }}>{this.state.inputError}</p>}
            <InputRow
              name="text"
              rowName="Passport Number"
              hover={"The number mentioned in your passport.\nالرقم المذكور في جواز سفرك"}
              value={passportNumber}
              onChange={(val) => {
                this.setState({ passportNumber: val })
                this.props.collectState('GI', {
                  passportNumber: val,
                  passportCountry: passportCountry,
                  passportExpiryDate: passportExpiryDate,
                  nationalNumber: nationalNumber
                })
              }}
            />
            <InputRow
              rowName="Passport Country Issued"
              value={passportCountry}
              name="select"
              data={this.props.countryData}
              onChange={(val) => {
                this.setState({ passportCountry: val })
                this.props.collectState('GI', {
                  passportNumber: passportNumber,
                  passportCountry: val,
                  passportExpiryDate: passportExpiryDate,
                  nationalNumber: nationalNumber
                })
              }}
            />
            <InputRow
              rowName="Passport Expiration Date"
              value={passportExpiryDate}
              name="date"
              onChange={(val) => {
                const dob = new Date(val)
                if (!isNaN(dob.getFullYear())) {
                  if (parseInt(dob.getFullYear()) <= 9999)   {
                    this.setState({ passportExpiryDate: val })
                    this.props.collectState('GI', {
                      passportNumber: passportNumber,
                      passportCountry: passportCountry,
                      passportExpiryDate: val,
                      nationalNumber: nationalNumber
                    })
                  }
                } else {
                  this.setState({ passportExpiryDate: '' })
                  this.props.collectState('GI', {
                    passportNumber: passportNumber,
                    passportCountry: passportCountry,
                    passportExpiryDate: '',
                    nationalNumber: nationalNumber
                  })
                }
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  render () {
    const { loading, error, pedError } = this.state
    if (loading) {
      return (<Loading />)
    }
    let body = ''
    const nat = parseInt(this.props.nationality)
    if (nat === 50) {
      body = this.renderLocal()
    } else if (nat !== 0 && !isNaN(nat)) {
      body = this.renderForeign()
    } else {
      body = <div style={{color:'red'}}>Please fill the Personal Information section first.</div>
    }
    return (
      <div>
        <p style={{ color: 'red' }}>{error}</p>
        {body}

        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>

      </div>
    )
  }
}
GovernmentInformation.propTypes = {
  countryData: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  nationality: PropTypes.number.isRequired,
  nationalIdNumber: PropTypes.string,
  passportNumber: PropTypes.string,
  passportCountry: PropTypes.number,
  incompleteApplicationId: PropTypes.number,
  passportExpiry: PropTypes.string,
  error: PropTypes.object,
  collectState: PropTypes.func
}
